import { render, staticRenderFns } from "./labeledlist.vue?vue&type=template&id=f143fce0&scoped=true&"
import script from "./labeledlist.vue?vue&type=script&lang=js&"
export * from "./labeledlist.vue?vue&type=script&lang=js&"
import style0 from "./labeledlist.vue?vue&type=style&index=0&id=f143fce0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f143fce0",
  null
  
)

export default component.exports